import React from 'react';
import NewTestPage from '../pages/NewTestPage';

/**
 * Composant contrôleur pour la nouvelle landing page moderne
 * Accessible via /landing/:token
 */
const LandingController: React.FC = () => {
  return <NewTestPage />;
};

export default LandingController;
